// extracted by mini-css-extract-plugin
export default {"pageSpinner":"PageSpinner-modules__pageSpinner__JPuCv"};